import { IconButton, Input, InputGroup, InputRightElement } from "@chakra-ui/react"
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons"

import { useState } from "react"

interface Props {
    placeholder: string,
    setPassword: (password: string) => void,
    isInvalid?: boolean,
    onBlur?: () => void
}

export const PasswordInput: React.FC<Props> = ({ placeholder, setPassword, isInvalid = false, onBlur }) =>  {
    const [show, setShow] = useState(false)
    const handleClick = () => setShow(!show)

    return (
        <InputGroup
            background="rgba(108, 117, 125, 0.08)"
            borderColor="transparent"
        >
            <Input
                className="form-input"
                pr='4.5rem'
                type={show ? 'text' : 'password'}
                isInvalid={isInvalid}
                textColor={isInvalid ? "#E53E3E" : "black"}
                placeholder={placeholder}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={onBlur}
            />
            <InputRightElement width='4.5rem'>
            <IconButton
                size='sm'
                icon={show ? <ViewIcon boxSize="1.5rem" /> : <ViewOffIcon boxSize="1.5rem" />}
                onClick={handleClick}
                aria-label="password-input"
            />
            </InputRightElement>
        </InputGroup>
    )
}